import {CHANGE_NUMBER_OF_CELLS} from "../constants/constants";

export const changeNumberOfCells = (newHeight) => {
    return {
        type : CHANGE_NUMBER_OF_CELLS,
        payload : newHeight
    }
};


// WEBPACK FOOTER //
// ./src/actions/changeNumberOfCells.js